import { styled } from '@linaria/react';
import { bodyFont, colors, fonts, layout, semantic, shadow, space } from '../../theme/tokens';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
  padding-bottom: ${space[5]};
`;

export const GalleryFrame = styled.div`
  --image-frame-mobile-height: 240px;
  --image-frame-desktop-height: 240px;
  position: relative;
  margin: 0 calc(-1 * ${space[5]});
  overflow: hidden;
  border-radius: ${layout.borderRadiusXl} ${layout.borderRadiusXl} 0 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    margin: ${space[5]} 0 0;
    border-radius: 0;
    overflow: visible;
  }
`;

export const GalleryCloseButton = styled.button`
  position: absolute;
  top: ${space[3]};
  right: ${space[3]};
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: ${layout.borderRadiusFull};
  background: ${colors.white};
  color: ${semantic.text.primary};
  font-size: ${fonts.size.sm};
  line-height: 1;
  cursor: pointer;
  box-shadow: ${shadow.sm};
  z-index: 2;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${space[4]};
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
`;

export const RoomName = styled.h3`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const MetaText = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
`;

export const PriceBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${space[1]};
  flex-shrink: 0;
  text-align: right;
`;

export const StayPrice = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
`;

export const NightPrice = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
`;

export const Description = styled.div`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
  line-height: 1.6;

  & p {
    margin: 0;
  }

  & p + p {
    margin-top: ${space[3]};
  }
`;

export const FeatureList = styled.ul`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.primary};
  margin: 0;
  padding-left: ${space[4]};
  display: flex;
  flex-direction: column;
  gap: ${space[2]};
`;

export const TotalDueRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${space[4]};
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  color: ${semantic.text.primary};
`;

export const TotalDueAmount = styled.span`
  font-weight: ${fonts.weight.semiBold};
`;

export const FooterContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${space[3]};
  padding: ${space[4]} ${space[5]};
`;
